// @purpose STATE
// Opens/closes templates/cotton/dialog.html + drawer.html's native <dialog> elements. Deliberately
// not Alpine: @alpinejs/focus isn't in frontend/package.json, so we lean on <dialog>.showModal() for
// focus-trap + Escape-to-close + ::backdrop, which the browser gives us for free — no focus-trap JS to
// maintain. One delegated listener (htmx-swapped content keeps working without re-binding).
export function initDialogs(root = document) {
  root.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-dialog-open]");
    if (opener) {
      const target = document.querySelector(opener.getAttribute("data-dialog-target"));
      if (target instanceof HTMLDialogElement) target.showModal();
      return;
    }
    const closer = event.target.closest("[data-dialog-close]");
    if (closer) {
      const explicit = closer.getAttribute("data-dialog-target");
      const target = explicit ? document.querySelector(explicit) : closer.closest("dialog");
      if (target instanceof HTMLDialogElement) target.close();
    }
  });

  // click on the ::backdrop (not inside the dialog's own box) closes it, matching the drawer/dialog
  // pattern everywhere else in the app (tap-outside-to-dismiss).
  root.addEventListener("click", (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.open) {
      const box = event.target.getBoundingClientRect();
      const inside =
        event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
      if (!inside) event.target.close();
    }
  });
}
